import React from 'react';

import { StyledInputField } from './inputField.style';

const InputField = (props) => {
  const {
    varient = 'normal',
    error = false,
    color = 'primary',
    sizevalue = 'big',
    onBtnClick,
    disabled = false,
    btnIcon,
    Name = '',
    helperText = '',
    isError = false,
    isNotAllow = false,
    isPlaceHolder = false,
    placeholderText,
    ...otherProps
  } = props;

  return (
    <div style={{ position: 'relative' }}>
      <span
        style={{
          position: 'absolute',
          left: '10px',
          top: '-12px',
          fontSize: '14px',
          zIndex: '1',
          maxWidth: '170px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: '#fff',
        }}
      >
        {Name}
      </span>
      <StyledInputField
        sizevalue={sizevalue}
        varient={varient}
        color={color}
        {...otherProps}
        disabled={disabled}
        placeholder={isPlaceHolder ? placeholderText : error ? helperText : Name}
        error={error}
        isNotAllow={isNotAllow}
      />
      {isError && (
        <span
          style={{
            position: 'absolute',
            left: '10px',
            bottom: '-19px',
            fontSize: '14px',
            zIndex: '1',
            maxWidth: '320px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'red',
          }}
        >
          {helperText}
        </span>
      )}
    </div>
  );
};

export default InputField;
